import { type NodeProps, type Node } from "@xyflow/react";
import LinkHandles from "./LinkHandles";
import styles from "./WorkflowNode.module.css";

interface FormData {
  formId: string;
  name: string;
  formType?: string;
  onRemove?: (formId: string) => void;
}

export default function FormNode({ data }: NodeProps<Node>) {
  const d = data as unknown as FormData;
  return (
    <div
      className={`${styles.card} ${styles.form}`}
      style={{ position: "relative" }}
    >
      <LinkHandles prefix="form" />
      {d.onRemove && (
        <button
          type="button"
          className={styles.groupRemove}
          style={{ position: "absolute", top: 4, right: 4 }}
          onClick={(e) => {
            e.stopPropagation();
            d.onRemove?.(d.formId);
          }}
          aria-label="Remove from canvas"
        >
          ×
        </button>
      )}
      <p className={styles.kind}>Form</p>
      <p className={styles.label}>{d.name}</p>
      {d.formType && <p className={styles.subtitle}>{d.formType}</p>}
    </div>
  );
}
